import { booleanAttribute, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { GalaxyUploaderComponent } from '../../uploader.module';

@Component({
  selector: 'glxy-file-drag-drop',
  templateUrl: './file-drag-drop.component.html',
  styleUrls: ['./file-drag-drop.component.scss'],
  standalone: false,
})
export class GalaxyFileDragDropComponent {
  @Input({ required: true }) uploaderTarget!: GalaxyUploaderComponent;
  @Input({ transform: booleanAttribute }) uploadingBlocked = false;
  @ViewChild('dropTarget') dropTargetEl: ElementRef | undefined;

  currentTimeout: number | null = null;

  preventBubbling(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
  }

  dragEnter(event: Event): void {
    if (this.uploadingBlocked) return;
    if (this.currentTimeout) window.clearTimeout(this.currentTimeout);
    this.preventBubbling(event);
    this.dropTargetEl?.nativeElement.classList.add('dragging-over');
  }

  dragLeave(event: Event): void {
    if (this.uploadingBlocked) return;
    this.currentTimeout = window.setTimeout(() => {
      this.dropTargetEl?.nativeElement.classList.remove('dragging-over');
    }, 100);
    this.preventBubbling(event);
  }
  fileDropped(event: Event): void {
    if (this.uploadingBlocked === true) return;
    this.preventBubbling(event);
    this.uploaderTarget.filesDropped(event);
  }
}
